import {platformAPI} from "../../../api/axiosConfig";
import {useQuery} from "react-query";

export function useGetCategories(clientID: string | null) {
    const {data, isLoading, error, refetch} = useQuery(
        ["siren-template-categories", clientID],
        async () => {
            const res = await platformAPI.get<string[]>("api/siren/templates/categories", {
                params: {clientID}
            })
            return res.data
        },
        {
            enabled: !!clientID,
            staleTime: 60 * 60 * 1000, // 1 hour — matches server-side cache TTL
        }
    );

    return {data, isLoading, error, refetch}
}